<div class="w-[1000px]">
  <svg viewBox="0 0 1350 600">
    <text x="50%" y="50%" fill="transparent" text-anchor="middle" dominant-baseline="middle">
      SCATTRE
    </text>
  </svg>
</div>
